module.exports = __webpack_public_path__ + "img/icon_menu3.490c22cb.jpg";